module.exports = __webpack_public_path__ + "img/www.lawyers.com.4884b724.png";